import * as React from 'react'

import { IProps } from './IProps'
import { BadgeText, Container } from './styles'

export const Badge: React.FC<IProps> = ({ text, isFinalSale }) => {
  return (
    <Container {...{ isFinalSale }}>
      <BadgeText textTransform='uppercase' textType='tag'>
        {text}
      </BadgeText>
    </Container>
  )
}
